/* global customElements, Service, ElementUtil */
import {LitElement, html} from 'lit';
import {property, customElement} from 'lit/decorators.js';
import {ElementUtil} from '../utils/elementUtil.js';
import {Service} from '../service/service.js';
import {pageRegistry} from '../utils/pageRegistry.js';
import {WorkspaceManagement} from './workspace/workspaceManagement.js';


class MainNav extends LitElement {
	
	static get properties() {
		return {
			about: {type: String},
			width: {type: Number},
			allMenuItems: {type: Array}
		};
	}

	constructor() {
		super();
		this.about = '';
		this.width = 300;
		this.allMenuItems = [];
		
		var sideNav = this;
		
		//firefox calls constructor and then render;
		//Chrome seems call render then the contractor when the element is used
		//this delay helps to normalize the browsers.
		setTimeout(function(){
			sideNav.init();
		});
		
	}
	
	render() {	
		return html`
			<style>
				.side-nav {
					padding-right: 10px;
					padding-left: 10px;
					border-right: 1px solid #dadfe5;
					overflow: hidden;
					height: 100%;
					display: flex;
					flex-direction: column;
					background-color: ${window.DL.colorMode.background};
				}

				.side-nav-scroll {
					flex: 1 1 auto;
					min-height: 0;
					overflow: auto;
				}
		
				.side-nav-scroll::-webkit-scrollbar-track {
					-webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
					border-radius: 8px;
					background-color: #a7a3a3;
				}

				.side-nav-scroll::-webkit-scrollbar {
					width: 10px;
					background-color: #575454;
				}

				.side-nav-scroll::-webkit-scrollbar-thumb {
					border-radius: 8px;
					-webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, .3);
					background-color: #555;
				}		

				.default-nav-link {
					background-color: ${this.getOffBackgroundColor()};
					display: block;
					color: ${this.getTextColor()};
					text-align: center;
					margin-top: 5px;		
					padding: 5px;
					border-radius: 4px 4px 4px 4px;
					cursor: pointer;
				}

				.default-nav-link:hover {
					opacity: .8;
					cursor: pointer;
				}
		
				.open-new-tab {
					float: right;
					padding-left: 7px;
					padding-right: 7px;
					margin-top: 2px;
					border-radius: 10px 10px 10px 10px;
					font-size: 13px;		
					background-color: rgba(255,255,255, 0.4);
				}
		
				.hide {
					display: none;
				}

				.workspace-toolbar {
					display: flex;
					align-items: center;
					justify-content: space-between;
					gap: 6px;
					padding: 6px 0 8px 0;
					border-bottom: 1px solid #dadfe5;
					margin-bottom: 4px;
					position: relative;
					flex: 0 0 auto;
					z-index: 50;
					background-color: ${window.DL.colorMode.background};
				}

				.workspace-toolbar-btn {
					cursor: pointer;
					border-radius: 4px;
					padding: 4px 6px;
					background-color: ${this.getOffBackgroundColor()};
					color: ${this.getTextColor()};
					border: 1px solid #c5c9ce;
					display: inline-flex;
					align-items: center;
					gap: 4px;
					min-width: 0;
				}

				.workspace-toolbar-btn:hover {
					opacity: 0.85;
				}

				.workspace-pages-btn {
					flex: 1 1 auto;
					justify-content: space-between;
					overflow: hidden;
				}

				.workspace-pages-label {
					overflow: hidden;
					text-overflow: ellipsis;
					white-space: nowrap;
					font-size: 13px;
				}

				.workspace-pages-dropdown {
					position: absolute;
					top: 100%;
					left: 0;
					right: 0;
					z-index: 40;
					background: ${window.DL.colorMode.background};
					border: 1px solid #c5c9ce;
					border-radius: 4px;
					box-shadow: 0 4px 12px rgba(0,0,0,0.2);
					max-height: 260px;
					overflow-y: auto;
				}

				.workspace-page-item {
					display: flex;
					align-items: center;
					justify-content: space-between;
					padding: 8px 10px;
					cursor: pointer;
					border-bottom: 1px solid #ececec;
					gap: 6px;
				}

				.workspace-page-item:hover {
					background-color: rgba(0,0,0,0.06);
				}

				.workspace-page-item.active {
					background-color: ${this.getBackgroundColor()};
					color: white;
				}

				.workspace-page-item-title {
					overflow: hidden;
					text-overflow: ellipsis;
					white-space: nowrap;
					flex: 1 1 auto;
					font-size: 13px;
				}

				.workspace-page-close {
					flex: 0 0 auto;
					cursor: pointer;
					padding: 2px 4px;
					border-radius: 3px;
				}

				.workspace-page-close:hover {
					background-color: #d40000;
					color: white;
				}

				.workspace-pages-empty {
					padding: 10px;
					font-size: 12px;
					opacity: 0.7;
				}
		
			</style>				
			<div class="side-nav">				
			</div>
		`;
	}
	
	init() {
		var sideNav = this;

		Service.getDashboardService().getDashboards().then(function(boards){
			Service.getUserService().getCurrentUser().then(function(user) {

				var createNewSection = function(accordingContainer, title, menuItems, sectionType, options){
					var options = options || {};
					if (!menuItems) {
						return null;
					}

					var newMenuItemsToAdd = [];
					menuItems.forEach(function(item){
						if (!item.permission || user.hasPermission(item.permission)) {
							newMenuItemsToAdd.push(item);
						}
					});

					if (newMenuItemsToAdd.length === 0) {
						return null;
					}
					if (!options.noSort) {
						newMenuItemsToAdd.sort(function (a, b) {
							if (a.subMenu && !b.subMenu) {
								return 1;
							} else if (!a.subMenu && b.subMenu) {
								return -1;
							} else if (a.subMenu && b.subMenu) {
								return a.title.localeCompare(b.title);
							} else {
								return a.title.localeCompare(b.title);
							}
						});
					}

					var setupContainer = document.createElement('vaadin-accordion-panel');
					setupContainer.setAttribute('theme', 'filled reverse');
					setupContainer.setAttribute('style', 'padding: 10px;');
					if (sectionType === 'ADMIN') {
						setupContainer.setAttribute('style', 'background-color: ' + window.DL.colorMode.adminMenu + '; padding: 10px;');
					}
					if (sectionType === 'ACCOUNT-MANAGMENT') {
						setupContainer.setAttribute('style', 'background-color: #536c83; padding: 10px;');
					}
					if (sectionType === 'SUBMENU') {
						setupContainer.setAttribute('style', 'background-color: #d3e0e3; padding: 10px;');					
					}								

					var titleElement = document.createElement('div');
					titleElement.setAttribute('slot', 'summary');
					//titleElement.setAttribute('style', 'padding: 5 10 10 5');                               
					titleElement.innerHTML = title;			
					setupContainer.append(titleElement);

					if (newMenuItemsToAdd) {

						var makeMenuItems = function(mainAccordingContainer, menuContainer, menuItems) {

							newMenuItemsToAdd.forEach(function(item) {
								//var wrapper = document.createElement('div');

								if (item.subMenu && 
									item.childMenuItems && 
									item.childMenuItems.length > 0) {

									var subAccordingContainer = ElementUtil.create({
										tag: 'vaadin-accordion',
										style: 'padding-top: 5px; padding-bottom: 5px; width: 104%;'									
									});								
									setupContainer.append(subAccordingContainer);
									createNewSection(subAccordingContainer, item.title, item.childMenuItems, 'SUBMENU');								

								} else {
									var menuItem = document.createElement('div');
									menuItem.setAttribute('class', 'default-nav-link');
									menuItem.setAttribute('style', 'width: 100%;');
									menuItem.innerHTML = item.title;
									menuItem.itemDetails = item;

									var openNewTab = document.createElement('span');
									openNewTab.setAttribute('class', 'open-new-tab hide');
									openNewTab.setAttribute('title', 'Open New Tab');
									openNewTab.innerHTML = '+';

									openNewTab.addEventListener('click', function (event) {
										window.open('view-' + item.key);
										event.stopPropagation();
										event.preventDefault();
									});

									menuItem.addEventListener('mouseover', function (event) {
										openNewTab.classList.remove('hide');
									});

									menuItem.addEventListener('mouseout', function (event) {
										openNewTab.classList.add('hide');
									});

									menuItem.append(openNewTab);

									menuItem.addEventListener('click', function () {
										sideNav.allMenuItems.forEach(function (itemElement) {
											itemElement.setAttribute('style', 'width: 100%');
											itemElement.setAttribute('theme', 'contrast primary');
										});
										menuItem.setAttribute('theme', 'primary');
										menuItem.setAttribute('style', 'width: 100%; background-color: ' + sideNav.getBackgroundColor() + '; box-shadow: 0px 0px 8px ' + sideNav.getBackgroundColor() + ';');

										//delay so the initial section is setup
										setTimeout(function () {
											menuItem.parentElement.opened = true;
										}, 100);

										//fire selection event
										var itemSelectEvent = new CustomEvent('itemSelect', {detail: menuItem.itemDetails});
										sideNav.dispatchEvent(itemSelectEvent);
									});
									//wrapper.append(menuItem);
									sideNav.allMenuItems.push(menuItem);

									menuContainer.append(menuItem);
								}

							});

							mainAccordingContainer.append(menuContainer);
						};
					};
					makeMenuItems(accordingContainer, setupContainer, newMenuItemsToAdd);


				};			

				var menuContainer = sideNav.shadowRoot.querySelector('div.side-nav');

				sideNav.buildWorkspaceToolbar(menuContainer);

				var scrollContainer = ElementUtil.create({
					tag: 'div',
					'class': 'side-nav-scroll'
				});
				menuContainer.append(scrollContainer);

				var accordingContainer = ElementUtil.create({
					tag: 'vaadin-accordion',
					style: 'padding-top: 10px; padding-bottom: 10px;', 
					theme: 'reverse'
				});			

				//load dashboards			
				var dashboards = [];
				boards.forEach(function(board){
					var dashId = board.dashboardId;
					if (board.defaultDashboard) {
						dashId = 'default';
					}
					dashboards.push({
						title: board.name,
						url: './views/dashboard.html',
						key: 'dash?id=' + dashId
					});
				});
				createNewSection(accordingContainer, 'Dashboards', dashboards);

				var unitManagementPages = [];
				unitManagementPages.push({
					title: 'Drivers',
					url: './views/unit/drivers.html',
					key: 'drivers',
					permission: 'DRIVER_MANAGEMENT:PAGE'
				});			

				unitManagementPages.push({
					title: 'Tractors',
					url: './views/unit/tractors.html',
					key: 'tractors',
					permission: 'TRACTOR_MANAGEMENT:PAGE'
				});			

				unitManagementPages.push({
					title: 'Trailers',
					url: './views/unit/trailers.html',
					key: 'trailers',
					permission: 'TRAILER_MANAGEMENT:PAGE'
				});

				unitManagementPages.push({
					title: 'Unit Groups',
					url: './views/unit/unitgroups.html',
					key: 'unit-groups',
					permission: 'UNITGROUP_MANAGEMENT:PAGE'
				});						
				createNewSection(accordingContainer, 'Units', unitManagementPages);

				var dataManagementPages = [];
				dataManagementPages.push({
					title: 'GPS Locations',
					url: './views/datamanagement/gpslocations.html',
					key: 'gps-manage',
					permission: 'GPS_MANAGEMENT:PAGE'
				});
				dataManagementPages.push({
					title: 'Fuel',
					url: './views/datamanagement/fuelpurchases.html',
					key: 'fuel-manage',
					permission: 'FUEL_MANAGEMENT:PAGE'
				});
				dataManagementPages.push({
					title: 'Distance Summaries',
					url: './views/datamanagement/distancesummaries.html',
					key: 'distance-summaries',
					permission: 'DISTANCE_SUMMARIES:PAGE'
				});					
				dataManagementPages.push({
					title: 'Dispatch',
					url: './views/datamanagement/dispatch.html',
					key: 'dispatch-manage',
					permission: 'TRIP_MANAGEMENT:PAGE'
				});
				dataManagementPages.push({
					title: 'Data Links',
					url: './views/datamanagement/datalinks.html',
					key: 'datalinks-manage',
					permission: 'DATA_LINKS:PAGE'
				});	
	//			dataManagementPages.push({
	//				title: 'SecureFuel Vehicle Positions',
	//				url: './views/securefuel/events.html',
	//				key: 'sf-events'
	//				//permission: 'COMPANY_BATCH_MANAGEMENT:PAGE'
	//			});			
				createNewSection(accordingContainer, 'Data Management', dataManagementPages, null, {
					noSort: true
				});

				var reportingPages = [];
				reportingPages.push({
					title: 'Reports',
					url: './views/reporting/reports.html',
					key: 'reports',
					permission: 'REPORTS:PAGE'
				});
				reportingPages.push({
					title: 'Close Reporting Periods',
					url: './views/reporting/close-reports.html',
					key: 'close-reports',
					permission: 'CLOSE_REPORTS:PAGE'
				});			
	//			reportingPages.push({
	//				title: 'Performance Reports',
	//				subMenu: true,
	//				childMenuItems: [
	//					{
	//						title: 'SecureFuel Events',
	//						url: './views/securefuel/tanklevels.html',
	//						key: 'sf-tanklevels'
	//								//permission: 'COMPANY_BATCH_MANAGEMENT:PAGE'
	//					},
	//					{
	//						title: 'Out of Route',
	//						url: './views/outofroute/outofroute.html',
	//						key: 'outofroute'
	//								//permission: 'COMPANY_BATCH_MANAGEMENT:PAGE'
	//					},
	//					{
	//						title: 'Distance',
	//						url: './views/performance/distance.html',
	//						key: 'pf-distance'
	//								//permission: 'COMPANY_BATCH_MANAGEMENT:PAGE'
	//					},
	//					{
	//						title: 'Fuel',
	//						url: './views/performance/fuel.html',
	//						key: 'pf-fuel'
	//								//permission: 'COMPANY_BATCH_MANAGEMENT:PAGE'
	//					},
	//					{
	//						title: 'Idle',
	//						url: './views/performance/idle.html',
	//						key: 'pf-idle'
	//								//permission: 'COMPANY_BATCH_MANAGEMENT:PAGE'
	//					},
	//					{
	//						title: 'MPG',
	//						url: './views/performance/mpg.html',
	//						key: 'pf-mpg'
	//								//permission: 'COMPANY_BATCH_MANAGEMENT:PAGE'
	//					}
	//				]				
	//				//permission: 'REPORTS:PAGE'
	//			});				
				createNewSection(accordingContainer, 'Reporting', reportingPages);

				var performanceReportsPages = [];
				performanceReportsPages.push({
					title: 'SecureFuel Events',
					url: './views/securefuel/tanklevels.html',
					key: 'sf-tanklevels'
					//permission: 'COMPANY_BATCH_MANAGEMENT:PAGE'
				});
				performanceReportsPages.push({
					title: 'Out of Route',
					url: './views/outofroute/outofroute.html',
					key: 'outofroute'
					//permission: 'COMPANY_BATCH_MANAGEMENT:PAGE'
				});
				performanceReportsPages.push({
					title: 'Distance',
					url: './views/performance/distance.html',
					key: 'pf-distance'
					//permission: 'COMPANY_BATCH_MANAGEMENT:PAGE'
				});
				performanceReportsPages.push({
					title: 'Fuel',
					url: './views/performance/fuel.html',
					key: 'pf-fuel'
					//permission: 'COMPANY_BATCH_MANAGEMENT:PAGE'
				});			
				performanceReportsPages.push({
					title: 'Idle',
					url: './views/performance/idle.html',
					key: 'pf-idle'
					//permission: 'COMPANY_BATCH_MANAGEMENT:PAGE'
				});
				performanceReportsPages.push({
					title: 'MPG',
					url: './views/performance/mpg.html',
					key: 'pf-mpg'
					//permission: 'COMPANY_BATCH_MANAGEMENT:PAGE'
				});							
			//	createNewSection(accordingContainer, 'Performance Reports', performanceReportsPages);			

				var companyToolsPages = [];	
				companyToolsPages.push({
					title: 'Tasks',
					url: './views/datamanagement/tasks.html',
					key: 'task-manage',
					permission: 'COMPANY_BATCH_MANAGEMENT:PAGE'
				});	
				companyToolsPages.push({
					title: 'Import History',
					url: './views/tools/importhistory.html',
					key: 'import-manage',
					permission: 'IMPORTS:PAGE'
				});
				companyToolsPages.push({
					title: 'Time Tools',
					url: './views/tools/timetools.html',
					key: 'time-tools',
					permission: 'TIME_TOOLS:PAGE'
				});
				createNewSection(accordingContainer, 'Tools', companyToolsPages);  

				var companyConfigPages = [];		

//				companyConfigPages.push({
//					title: 'SecureFuel Auth Rules',
//					url: './views/securefuel/grouprules.html',
//					key: 'sf-grouprules'
//					//permission: 'COMPANY_BATCH_MANAGEMENT:PAGE'
//				});			

				companyConfigPages.push({
					title: 'City X References',
					url: './views/companyadmin/cityxrefs.html',
					key: 'city-x-refs',
					permission: 'CITY_X_REFERENCE_MANAGEMENT:PAGE'
				});

				companyConfigPages.push({
					title: 'Routing Options',
					url: './views/companyadmin/routingOptions.html',
					key: 'routing-options',
					permission: 'GEOSPATIAL_OPTIONS:PAGE'
				});

				companyConfigPages.push({
					title: 'Integrations',
					url: './views/datamanagement/integrations.html',
					key: 'integrations-manage',
					permission: 'INTEGRATIONS:PAGE'
				});

				companyConfigPages.push({
					title: 'APIs',
					url: './views/datamanagement/external-integrations.html',
					key: 'external-integrations',
					permission: 'API_SERVICE_ACCOUNTS:PAGE'
				});			

				companyConfigPages.push({
					title: 'Data Locks',
					url: './views/datamanagement/datalocks.html',
					key: 'datalock-manage',
					permission: 'DATA_LOCKS:PAGE'
				});			

				companyConfigPages.push({
					title: 'Data Watches',
					url: './views/datamanagement/datawatches.html',
					key: 'datawatches-manage',
					permission: 'DATA_WATCHES:PAGE'
				});	

				companyConfigPages.push({
					title: 'Auto Units',
					url: './views/unit/autounits.html',
					key: 'autounits-manage',
					permission: 'AUTOUNIT_MANAGEMENT:PAGE'
				});

				companyConfigPages.push({
					title: 'Auto Groups',
					url: './views/unit/autogroups.html',
					key: 'autogroups-manage',
					permission: 'AUTOGROUP_MANAGEMENT:PAGE'
				});

				companyConfigPages.push({
					title: 'Data Transform Rule Sets',
					url: './views/datamanagement/data-transform-rulesets.html',
					key: 'data-transform-rulesets',
					permission: 'DATA_TRANSFORM_RULESET_MANAGEMENT:PAGE'
				});

				companyConfigPages.push({
					title: 'Unit Matching',
					url: './views/unit/unitmatching.html',
					key: 'unitmatching',
					permission: 'UNIT_MATCHING_MANAGEMENT:PAGE'
				});	

				companyConfigPages.push({
					title: 'Data Filtering',
					url: './views/datamanagement/datafiltering.html',
					key: 'datafiltering',
					permission: 'DATA_FILTER_MANAGEMENT:PAGE'
				});

				companyConfigPages.push({
					title: 'GPS Calculation Options',
					url: './views/datamanagement/calcpipeline.html',
					key: 'calc-options',
					permission: 'CALC_PREFERENCES:PAGE'
				});			

				companyConfigPages.push({
					title: 'GPS Filtering',
					url: './views/datamanagement/gpsfiltering.html',
					key: 'gps-filtering',
					permission: 'GPS_FILTER_MANAGEMENT:PAGE'
				});	
				
				companyConfigPages.push({
					title: 'Fueltax Preferences',
					url: './views/companyadmin/fueltaxPreferences.html',
					key: 'fueltax-preference',
					permission: 'FUELTAX_PREFERENCES:PAGE'
				});					

				createNewSection(accordingContainer, 'Configuration', companyConfigPages);                               


				var companyAdminPages = [];
				companyAdminPages.push({
					title: 'Archives',
					url: './views/datamanagement/archives.html',
					key: 'company-data-archives',
					permission: 'ADMIN_ARCHIVES:PAGE'
				});

				companyAdminPages.push({
					title: 'Company Information',
					url: './views/companyadmin/companyManagement.html',
					key: 'company-manage',
					permission: 'COMPANY_MANAGEMENT:PAGE'
				});

				companyAdminPages.push({
					title: 'User Roles',
					url: './views/companyadmin/roleManagement.html',
					key: 'role-manage',
					permission: 'COMPANY_ROLE_MANAGEMENT:PAGE'
				});				

				companyAdminPages.push({
					title: 'Users',
					url: './views/companyadmin/userManagement.html',
					key: 'user-manage',
					permission: 'COMPANY_USER_MANAGEMENT:PAGE'
				});

				companyAdminPages.push({
					title: 'Alerts',
					url: './views/companyadmin/alerts.html',
					key: 'company-alerts',
					permission: 'ALERT_MANAGEMENT:PAGE'
				});

				companyAdminPages.push({
					title: 'Billing Account',
					url: './views/companyadmin/accountInfo.html',
					key: 'account-info',
					permission: 'COMPANY_ACCOUNT_MANAGEMENT:PAGE'
				});	

				createNewSection(accordingContainer, 'Company Admin', companyAdminPages);

				var accountManagemnentPages = [];
				accountManagemnentPages.push({
					title: 'Accounts',
					url: './views/accountmanagement/accounts.html',
					key: 'account-management',
					permission: 'ACCOUNT_MANAGEMENT:PAGE'
				});

				createNewSection(accordingContainer, '<span style="color: white;">Account Management</span>', accountManagemnentPages, 'ACCOUNT-MANAGMENT');

				var systemPages = [];
				systemPages.push({
					title: 'Security Policy',
					url: './views/system/securityPolicy.html',
					key: 'admin-security-policy',
					permission: 'ADMIN_SECURITY_POLICY:PAGE'
				});

				systemPages.push({
					title: 'Lookups',
					url: './views/system/lookups.html',
					key: 'admin-lookup-manage',
					permission: 'ADMIN_LOOKUP_MANAGEMENT:PAGE'
				});

				systemPages.push({
					title: 'Alerts',
					url: './views/system/alerts.html',
					key: 'admin-alerts',
					permission: 'ADMIN_ALERTS_MANAGEMENT:PAGE'
				});

				systemPages.push({
					title: 'Branding',
					url: './views/system/branding.html',
					key: 'admin-branding',
					permission: 'ADMIN_BRANDING_MANAGEMENT:PAGE'
				});

				systemPages.push({
					title: 'Help',
					url: './views/system/help.html',
					key: 'admin-help',
					permission: 'ADMIN_HELP_MANAGEMENT:PAGE'
				});

				systemPages.push({
					title: 'Media',
					url: './views/system/media.html',
					key: 'admin-media',
					permission: 'ADMIN_MEDIA_MANAGEMENT:PAGE'
				});			

				systemPages.push({
					title: 'Feedback',
					url: './views/system/feedback.html',
					key: 'admin-feedback',
					permission: 'ADMIN_FEEDBACK_MANAGEMENT:PAGE'
				});

				systemPages.push({
					title: 'Templates',
					url: './views/system/templates.html',
					key: 'admin-template',
					permission: 'ADMIN_FEEDBACK_MANAGEMENT:PAGE'
				});

				systemPages.push({
					title: 'Scripts',
					url: './views/system/scripts.html',
					key: 'admin-scripts',
					permission: 'ADMIN_APP_SCRIPTS:PAGE'
				});			

				systemPages.push({
					title: 'Notifications',
					url: './views/system/notifications.html',
					key: 'admin-notifications',
					permission: 'ADMIN_NOTIFICATION_MANAGEMENT:PAGE'
				});				

				systemPages.push({
					title: 'Message Queue',
					url: './views/system/messagequeue.html',
					key: 'admin-messagequeue',
					permission: 'ADMIN_MESSAGEQUEUE_MANAGEMENT:PAGE'
				});

				systemPages.push({
					title: 'Email History',
					url: './views/system/emailHistory.html',
					key: 'admin-email-history',
					permission: 'ADMIN_EMAIL_HISTORY:PAGE'
				});	

				systemPages.push({
					title: 'Tracking',
					url: './views/system/tracking.html',
					key: 'admin-tracking',
					permission: 'ADMIN_TRACKING_MANAGEMENT:PAGE'
				});		

				systemPages.push({
					title: 'Test Cases',
					url: './views/system/testCases.html',
					key: 'admin-test-case',
					permission: 'ADMIN_SYSTEM_TEST:PAGE'
				});			

				systemPages.push({
					title: 'System Tools',
					url: './views/system/tools.html',
					key: 'admin-system-tools',
					permission: 'ADMIN_SYSTEM:PAGE'
				});	

				systemPages.push({
					title: 'System Statistics',
					url: './views/system/stats.html',
					key: 'admin-stats',
					permission: 'ADMIN_SYSTEM:PAGE'
				});

//use /docs
//				systemPages.push({
//					title: 'API Documentation',					
//					url: './views/system/apidocs.html',
//					key: 'api-docs',
//					permission: 'API_DOCUMENTATION:PAGE'
//				});

				systemPages.push({
					title: 'Application Modules',
					url: './views/system/applicationModules.html',
					key: 'admin-application-modules',
					permission: 'ADMIN_APPLICATION_MODULES:PAGE'
				});
				systemPages.push({
					title: 'Feature Switches',
					url: './views/system/featureSwitches.html',
					key: 'feature-switches',
					permission: 'ADMIN_FEATURE_SWITCH:PAGE'
				});
				createNewSection(accordingContainer, '<vaadin-icon icon="vaadin:cogs"></vaadin-icon> <b>Admin - Application</b>', systemPages, 'ADMIN');

				var billingPages = [];
				billingPages.push({
					title: 'Account Applications',
					url: './views/admin/billing/applications.html',
					key: 'admin-applications-manage',
					permission: 'ADMIN_CUSTOMER_APPLICATIONS:PAGE'
				});

				billingPages.push({
					title: 'Accounts',
					url: './views/admin/billing/accounts.html',
					key: 'admin-accounts-manage',
					permission: 'ADMIN_BILLING_ACCOUNTS:PAGE'
				});

				billingPages.push({
					title: 'Factoring',
					url: './views/admin/billing/factoring.html',
					key: 'admin-factoring-manage',
					permission: 'ADMIN_BILLING_ACCOUNTS:PAGE'
				});				
				billingPages.push({
					title: 'Sale Reps',
					url: './views/admin/billing/salereps.html',
					key: 'admin-sale-resps-manage',
					permission: 'ADMIN_BILLING_SALES_REPS:PAGE'
				});
				billingPages.push({
					title: 'Bundles',
					url: './views/admin/billing/bundles.html',
					key: 'admin-bundles-manage',
					permission: 'ADMIN_BILLING_BUNDLES:PAGE'
				});
				billingPages.push({
					title: 'EFS Accounts',
					url: './views/admin/billing/efsaccounts.html',
					key: 'admin-tch-accounts-manage',
					permission: 'ADMIN_BILLING_TCH_ACCOUNTS:PAGE'
				});
				billingPages.push({
					title: 'Promotions',
					url: './views/admin/billing/promotions.html',
					key: 'admin-promotions-manage',
					permission: 'ADMIN_BILLING_PROMOTIONS:PAGE'
				});
				billingPages.push({
					title: 'Referrals',
					url: './views/admin/billing/referrals.html',
					key: 'admin-referrals-manage',
					permission: 'ADMIN_BILLING_REFERRALS:PAGE'
				});	
				billingPages.push({
					title: 'Reference Companies',
					url: './views/admin/billing/referenceCompany.html',
					key: 'admin-reference-company-manage',
					permission: 'ADMIN_BILLING_REFERENCE_COMPANY:PAGE'
				});
				billingPages.push({
					title: 'Products',
					url: './views/admin/billing/products.html',
					key: 'admin-products-manage',
					permission: 'ADMIN_BILLING_PRODUCTS:PAGE'
				});						
				createNewSection(accordingContainer, 'Admin - Billing', billingPages, 'ADMIN');

				var accountPages = [];
				accountPages.push({
					title: 'Companies',
					url: './views/admin/accounts/companies.html',
					key: 'admin-company-manage',
					permission: 'ADMIN_COMPANY_MANAGEMENT:PAGE'
				});
				
				accountPages.push({
					title: 'Company Type Config',
					url: './views/admin/accounts/companyTypeConfigs.html',
					key: 'admin-company-type-config-manage',
					permission: 'ADMIN_COMPANY_TYPE_CONFIG:PAGE'
				});				
				
				accountPages.push({
					title: 'Roles',
					url: './views/admin/accounts/securityRoles.html',
					key: 'admin-security-roles',
					permission: 'ADMIN_SECURITY_ROLES:PAGE'
				});

				accountPages.push({
					title: 'Users',
					url: './views/admin/accounts/userManagement.html',
					key: 'admin-user-manage',
					permission: 'ADMIN_USER_MANAGEMENT:PAGE'
				});

				createNewSection(accordingContainer, 'Admin - Companies', accountPages, 'ADMIN');			

				var dataManagementPages = [];

				dataManagementPages.push({
					title: 'Archives',
					url: './views/admin/datamanagement/archives.html',
					key: 'admin-archives',
					permission: 'ADMIN_ARCHIVES:PAGE'
				});


				dataManagementPages.push({
					title: 'Data Migration',
					url: './views/admin/datamanagement/datamigration.html',
					key: 'admin-data-migration',
					permission: 'ADMIN_DATA_MIGRATION:PAGE'
				});

				dataManagementPages.push({
					title: 'Batch Tasks',
					url: './views/admin/datamanagement/admintasks.html',
					key: 'admin-task-manage',
					permission: 'ADMIN_BATCH_MANAGEMENT:PAGE'
				});

				dataManagementPages.push({
					title: 'Undo Management',
					url: './views/admin/datamanagement/undo.html',
					key: 'admin-undo-manage',
					permission: 'ADMIN_UNDO_MANAGEMENT:PAGE'
				});

				dataManagementPages.push({
					title: 'Data Watches',
					url: './views/admin/datamanagement/datawatches.html',
					key: 'admin-datawatches-manage',
					permission: 'ADMIN_DATA_WATCHES:PAGE'
				});	
				dataManagementPages.push({
					title: 'Data Retention Policies',
					url: './views/admin/datamanagement/data-retention-policy.html',
					key: 'admin-dataretention-policies',
					permission: 'ADMIN_DATA_RETENTION_POLICY:PAGE'
				});
				dataManagementPages.push({
					title: 'Custom Import Tool',
					url: './views/admin/datamanagement/custom-import-tool.html',
					key: 'admin-custom-imports',
					permission: 'ADMIN_CUSTOM_DATA_HANDLER:PAGE'
				});
				dataManagementPages.push({
					title: 'Import History',
					url: './views/admin/datamanagement/import-history.html',
					key: 'admin-import-manage',
					permission: 'ADMIN_IMPORTS:PAGE'
				});
				dataManagementPages.push({
					title: 'Format Visibility',
					url: './views/admin/datamanagement/format-visibility.html',
					key: 'admin-format-visibility',
					permission: 'ADMIN_DATA_HANDLER_VISIBILITY:PAGE'
				});			
				dataManagementPages.push({
					title: 'Admin Drivers',
					url: './views/admin/datamanagement/admin-drivers.html',
					key: 'admin-drivers',
					permission: 'ADMIN_DRIVERS:PAGE'
				});
				dataManagementPages.push({
					title: 'Admin Tractors',
					url: './views/admin/datamanagement/admin-tractors.html',
					key: 'admin-tractors',
					permission: 'ADMIN_TRACTORS:PAGE'
				});				
				dataManagementPages.push({
					title: 'Admin Trailers',
					url: './views/admin/datamanagement/admin-trailers.html',
					key: 'admin-trailers',
					permission: 'ADMIN_TRAILERS:PAGE'
				});
				
				dataManagementPages.push({
					title: 'Admin GPS',
					url: './views/admin/datamanagement/admin-gps.html',
					key: 'admin-gps-management',
					permission: 'ADMIN_GPS_MANAGEMENT:PAGE'
				});
				dataManagementPages.push({
					title: 'Admin Fuel',
					url: './views/admin/datamanagement/admin-fuel.html',
					key: 'admin-fuel-management',
					permission: 'ADMIN_FUEL_MANAGEMENT:PAGE'
				});
				dataManagementPages.push({
					title: 'Admin Distance Summary',
					url: './views/admin/datamanagement/admin-distance-summaries.html',
					key: 'admin-distance-summaries',
					permission: 'ADMIN_DISTANCE_SUMMARIES:PAGE'
				});
				dataManagementPages.push({
					title: 'Admin Trips',
					url: './views/admin/datamanagement/admin-trips.html',
					key: 'admin-trip-management',
					permission: 'ADMIN_TRIP_MANAGEMENT:PAGE'
				});

				createNewSection(accordingContainer, 'Admin - Data Management', dataManagementPages, 'ADMIN');

				var fuelTaxAdminPages = [];
				fuelTaxAdminPages.push({
					title: 'IFTA Rates',
					url: './views/admin/fueltax/ifta-rates.html',
					key: 'admin-ifta-rates',
					permission: 'ADMIN_IFTA_TAX_RATES:PAGE'
				});				
				fuelTaxAdminPages.push({
					title: 'State Rates',
					url: './views/admin/fueltax/state-rates.html',
					key: 'admin-state-rates',
					permission: 'ADMIN_STATE_TAX_RATES:PAGE'
				});
				fuelTaxAdminPages.push({
					title: 'CRA Rates',
					url: './views/admin/fueltax/cra-rates.html',
					key: 'admin-cra-rates',
					permission: 'ADMIN_CRA_TAX_RATES:PAGE'
				});			
				createNewSection(accordingContainer, 'Admin - Fueltax', fuelTaxAdminPages, 'ADMIN');			

				var integrationAdminPages = [];
				integrationAdminPages.push({
					title: 'Integrations',
					url: './views/admin/integrations/integrations.html',
					key: 'admin-integrations-manage',
					permission: 'ADMIN_INTEGRATIONS:PAGE'
				});
				integrationAdminPages.push({
					title: 'APIs',
					url: './views/admin/integrations/external-integrations.html',
					key: 'admin-external-integrations',			
					permission: 'ADMIN_SERVICE_ACCOUNTS:PAGE'
				});
				integrationAdminPages.push({
					title: 'Integration Input Logs',
					url: './views/admin/integrations/logs.html',
					key: 'admin-integration-logs',
					permission: 'ADMIN_INTEGRATION_LOGS:PAGE'
				});				
				createNewSection(accordingContainer, 'Admin - Integrations', integrationAdminPages, 'ADMIN');			

				var reportAdminPages = [];
				reportAdminPages.push({
					title: 'Reports',
					url: './views/admin/reports/reports.html',
					key: 'admin-reports',
					permission: 'ADMIN_REPORTS:PAGE'
				});
				reportAdminPages.push({
					title: 'Scheduled Reports',
					url: './views/admin/reports/scheduledReports.html',
					key: 'admin-scheduled-reports',
					permission: 'ADMIN_SCHEDULED_REPORTS:PAGE'
				});
				reportAdminPages.push({
					title: 'Report Visibility',
					url: './views/admin/reports/reportVisibility.html',
					key: 'admin-report-visibility',
					permission: 'ADMIN_REPORTS_VISIBILITY:PAGE'
				});
				reportAdminPages.push({
					title: 'Custom Report Template',
					url: './views/admin/reports/customTemplateReports.html',
					key: 'admin-report-templates',
					permission: 'ADMIN_REPORT_TEMPLATES:PAGE'
				});				
				createNewSection(accordingContainer, 'Admin - Reporting', reportAdminPages, 'ADMIN');

				var routingAdminPages = [];
				routingAdminPages.push({
					title: 'City X References',
					url: './views/admin/routing/cityxrefs.html',
					key: 'admin-cityxrefs',
					permission: 'ADMIN_CITY_X_REFERENCES:PAGE'
				});
				routingAdminPages.push({
					title: 'Postal Code City',
					url: './views/admin/routing/postalcodecities.html',
					key: 'admin-postalcodecities',
					permission: 'ADMIN_POSTAL_CODE_CITIES:PAGE'
				});
				routingAdminPages.push({
					title: 'Routing Tools',
					url: './views/admin/routing/routingTools.html',
					key: 'admin-routingtools',
					permission: 'ROUTING_TOOLS:PAGE'
				});
				routingAdminPages.push({
					title: 'App Routing Options',
					url: './views/admin/routing/routingOptions.html',
					key: 'admin-routing-options',
					permission: 'ADMIN_GEOSPATIAL_OPTIONS:PAGE'
				});
				createNewSection(accordingContainer, 'Admin - Routing', routingAdminPages, 'ADMIN');

				var secureFuelAdminPages = [];
//				secureFuelAdminPages.push({
//					title: 'Alert Events',
//					url: './views/admin/securefuel/alertevents.html',
//					key: 'admin-sf-alert-events'
//					//permission: 'ADMIN_GEOSPATIAL_OPTIONS:PAGE'
//				});
				secureFuelAdminPages.push({
					title: 'Vehicle Positions',
					url: './views/admin/securefuel/events.html',
					key: 'admin-sf-events',
					permission: 'ADMIN_SECURE_FUEL_EVENTS:PAGE'
				});
				secureFuelAdminPages.push({
					title: 'Group Auth Rules',
					url: './views/admin/securefuel/grouprules.html',
					key: 'admin-sf-auth-rules',
					permission: 'ADMIN_SECURE_FUEL_AUTH_GROUP:PAGE'
				});
//				secureFuelAdminPages.push({
//					title: 'Pre-Auths',
//					url: './views/admin/securefuel/preauths.html',
//					key: 'admin-sf-preauths'
//					//permission: 'ADMIN_GEOSPATIAL_OPTIONS:PAGE'
//				});
//				secureFuelAdminPages.push({
//					title: 'Post-Auths',
//					url: './views/admin/securefuel/postauths.html',
//					key: 'admin-sf-postauths'
//					//permission: 'ADMIN_GEOSPATIAL_OPTIONS:PAGE'
//				});
				secureFuelAdminPages.push({
					title: 'Units',
					url: './views/admin/securefuel/units.html',
					key: 'admin-sf-unit',
					permission: 'ADMIN_SECURE_FUEL_UNIT:PAGE'
				});			
				createNewSection(accordingContainer, 'Admin - Secure Fuel', secureFuelAdminPages, 'ADMIN');


				scrollContainer.append(accordingContainer);	

				var readyEvent = new CustomEvent('ready', { detail: 'loaded' });
				sideNav.dispatchEvent(readyEvent);			
			});	
		});

	}
	
	buildWorkspaceToolbar(menuContainer) {
		var sideNav = this;

		var pagesLabel = ElementUtil.create({
			tag: 'span',
			'class': 'workspace-pages-label',
			innerHTML: 'Pages'
		});

		var pagesButton = ElementUtil.create({
			tag: 'button',
			type: 'button',
			'class': 'workspace-toolbar-btn workspace-pages-btn',
			title: 'Open pages',
			children: [
				pagesLabel,
				{
					tag: 'vaadin-icon',
					icon: 'vaadin:angle-down',
					style: 'width: 14px; height: 14px; flex: 0 0 auto;'
				}
			]
		});

		var pagesDropdown = ElementUtil.create({
			tag: 'div',
			'class': 'workspace-pages-dropdown hide'
		});

		var cogButton = ElementUtil.create({
			tag: 'button',
			type: 'button',
			'class': 'workspace-toolbar-btn',
			title: 'Workspace management',
			children: [
				{
					tag: 'vaadin-icon',
					icon: 'vaadin:cog',
					style: 'width: 18px; height: 18px;'
				}
			]
		});

		var toolbar = ElementUtil.create({
			tag: 'div',
			'class': 'workspace-toolbar',
			children: [
				cogButton,
				pagesButton,
				pagesDropdown
			]
		});

		menuContainer.append(toolbar);

		var refreshPagesDropdown = function() {
			var pages = pageRegistry.getOpenPages();
			var activePageKey = pageRegistry.activePageKey;
			pagesDropdown.innerHTML = '';

			if (pages.length === 0) {
				pagesDropdown.append(ElementUtil.create({
					tag: 'div',
					'class': 'workspace-pages-empty',
					innerHTML: 'No open pages'
				}));
				pagesLabel.innerHTML = 'Pages';
				return;
			}

			var activePage = pages.find(function(page) {
				return page.pageKey === activePageKey;
			});
			pagesLabel.innerHTML = activePage ? activePage.title : 'Pages (' + pages.length + ')';

			pages.forEach(function(page) {
				var isActive = page.pageKey === activePageKey;
				var titleNode = ElementUtil.create({
					tag: 'span',
					'class': 'workspace-page-item-title',
					innerHTML: page.title + (page.mounted ? '' : ' *')
				});
				var closeNode = ElementUtil.create({
					tag: 'span',
					'class': 'workspace-page-close',
					title: 'Close page',
					innerHTML: '×',
					listeners: {
						click: function(event) {
							event.stopPropagation();
							var mainContent = document.querySelector('#mainContent');
							if (mainContent) {
								mainContent.closePage(page.pageKey);
							}
							pagesDropdown.classList.add('hide');
						}
					}
				});
				var item = ElementUtil.create({
					tag: 'div',
					'class': 'workspace-page-item' + (isActive ? ' active' : ''),
					children: [titleNode, closeNode],
					listeners: {
						click: function() {
							var mainContent = document.querySelector('#mainContent');
							if (mainContent) {
								mainContent.openOrFocus({
									key: page.pageKey,
									url: page.url,
									title: page.title
								}).then(function() {
									mainContent.dispatchPageActivated(page.pageKey);
								});
							}
							pagesDropdown.classList.add('hide');
						}
					}
				});
				pagesDropdown.append(item);
			});
		};

		pagesButton.addEventListener('click', function(event) {
			event.stopPropagation();
			refreshPagesDropdown();
			pagesDropdown.classList.toggle('hide');
		});

		cogButton.addEventListener('click', function(event) {
			event.stopPropagation();
			pagesDropdown.classList.add('hide');
			WorkspaceManagement.open();
		});

		pagesDropdown.addEventListener('click', function(event) {
			event.stopPropagation();
		});

		document.addEventListener('click', function() {
			pagesDropdown.classList.add('hide');
		});

		pageRegistry.onChange(function() {
			refreshPagesDropdown();
		});
		refreshPagesDropdown();
	}

	getBackgroundColor() {
		return window.DL.Branding.navBackgroundColor;	
	}
	
	getOffBackgroundColor() {
		return window.DL.Branding.navOffBackgroundColor;	
	}	
	
	getTextColor() {
		return window.DL.Branding.navTextColor;
	}
	
};
customElements.define('dl-main-sidenav', MainNav);

